import {ContentLabPlan} from '@/types/models/pricing/contentLabPlan';
import contentStudioSubscriptionFetchers from '@/api/fetchers/content-studio/subscription';
import useBrandId from '@/hooks/use-brand-id';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, PLANS} from '../consts';

function usePlansQuery(isEnabled = true) {
  const brandId = useBrandId();

  const response = useReactQuery<ContentLabPlan[]>({
    queryKey: [CONTENT_LAB, PLANS, brandId],
    queryFn: contentStudioSubscriptionFetchers.plans,
    enabled: !!brandId && isEnabled,
  });

  const plansData = response.data;
  return {...response, plansData, isPlansDataFetched: response.isFetched};
}

export default usePlansQuery;
